import React from 'react'
import { useHistory, useLocation } from 'react-router'

export default function ScreenChanger() {
  const history = useHistory()
  const location = useLocation()
  const path = location.pathname
  const toggle = () => {
    const newScreen = path === '/' ? '/login' : '/'
    history.push(newScreen)
  }
  return (
    <div
      onClick={toggle}
      className="bg-gray-300 py-2 px-4 m-auto mt-4 w-1/2 rounded-full flex justify-between"
    >
      <p
        className={`${
          path === '/' ? 'bg-dartsee-theme-green text-white' : ''
        } py-2 px-4 rounded-full`}
      >
        Guest
      </p>
      <p
        className={`${
          path === '/login' ? 'bg-dartsee-theme-green text-white' : ''
        } py-2 px-4 rounded-full`}
      >
        Log in
      </p>
    </div>
  )
}
